"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputKey = void 0;
const KHEventHandler_1 = require("../../KHEventHandler");
/**
 * Input key that specifies the state of one key. Managers of this key must
 * update it once and only once per frame, or strange behavior can occur.
 */
class KHInputKey extends KHEventHandler_1.KHEventHandler {
    constructor() {
        super([KHInputKey.EVENT_KEY_UPDATE]);
        this.down = false;
        this.justDown = false;
    }
    update(down) {
        let justDown = down && !this.down;
        this.updateInternal(down, justDown);
    }
    updateInternal(down, justDown) {
        let changed = this.justDown != justDown || this.down != down;
        this.justDown = justDown;
        this.down = down;
        if (changed) {
            this.emitEvent(KHInputKey.EVENT_KEY_UPDATE, null);
        }
    }
    isDown() {
        return this.down;
    }
    isJustDown() {
        return this.justDown;
    }
}
exports.KHInputKey = KHInputKey;
KHInputKey.EVENT_KEY_UPDATE = "ku";
